import { isInStandaloneMode } from '../../../sw/util';

export const VERSION_CHECK_INTERVAL = (isInStandaloneMode ? 2 : 5) * 60_000;
export const KYC_CHECK_INTERVAL = 5 * 60_000;
export const KYC_PASSED_CHECK_INTERVAL = 4 * 60 * 60_000;
export const MIN_BALANCE_TO_CREATE_SERVICE = 100;
export const SUBSCRIPTIONS_CHECK_INTERVAL = 60 * 60_000;
